import Asset from "../../requests/apa/Asset";
import Translator from '../../requests/apa/Translator'
import RequestManager from "../../requests/RequestManager";
import PBIFromRegisterTask from "../../requests/tasks/payway/PBIFromRegisterTask";
import Utils from "../../utils/Utils";
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import {getTransactionalPrice, getTransactionalTax, getTransactionalBonus, getTransactionalBonusComplement} from '../utils/Utils';
import {TRANSACTION_COMPONENT_LANDING, TRANSACTION_COMPONENT_PLAN_SELECTOR} from '../utils/constants';

export const getPlans = (params) => {
    const pbiFromRegisterTask = new PBIFromRegisterTask(params);
    return RequestManager.addRequest(pbiFromRegisterTask);
}

export const parsePlans = (plans, handlePlanClick = () => {}, labels) => plans.map(plan => {
   return parsePlan(plan, handlePlanClick, labels);
});

export const parsePlan = (plan, handlePlanClick, labels) => {
    const region = DeviceStorage.getItem("region") || "default";
    let backgroundAssetImage = Asset.get(`${plan.banner || ''}`.toLowerCase());
    const fallbackImage = Asset.get(`${plan.banner || ''}`.toLowerCase());

    plan.request = Utils.getRequest(plan.linkworkflowstart);

    // * If the region is not default, we try to get the image with the region
    if (region !== 'default') {
        backgroundAssetImage = Asset.get(`${plan.banner || ''}_${region}`.toLowerCase());
        
        //* If the image is not found, we use the default one
        if (backgroundAssetImage === `${plan.banner}_${region}`) {
            backgroundAssetImage = Asset.get(`${plan.banner || ''}`.toLowerCase());
        }
    }

    const providerLogo = Asset.get(`transactional_${plan.family}_logo`);
    /**
     * Only use in plan selector
     * @param alineacion must be a value Izquierda, Derecha o Centrado.
     * @param region param optional
     */
    const providerLogoPlanSelectorRegion = Asset.get(`SelectorDePlan_Tarjeta_ImagenLogo_${plan.family}_Centrado_${region}`);
    const providerLogoPlanSelectorNoRegion = Asset.get(`SelectorDePlan_Tarjeta_ImagenLogo_${plan.family}_Centrado`);
    const validateProviderLogo = providerLogoPlanSelectorRegion.includes('SelectorDePlan_Tarjeta_ImagenLogo_');
    const providerLogoPlanSelector = validateProviderLogo ? providerLogoPlanSelectorNoRegion : providerLogoPlanSelectorRegion;
    const buttonColorText = Translator.get(`${plan.style || ''}_text`);
    const buttonColorBG = Translator.get(`${plan.style || ''}`);
    const isButtonVisible = plan.hasOwnProperty('purchasable') ? plan.purchasable : true;
    const planSelectorPrice = getTransactionalPrice({
        component: TRANSACTION_COMPONENT_PLAN_SELECTOR,
        currency:plan.currency, 
        price:plan.price,
    });
    const planSelectorTax = getTransactionalTax({
        component: TRANSACTION_COMPONENT_PLAN_SELECTOR,
        producttype: plan.producttype,
        periodicity: plan.periodicity
    });
    const planSelectorBonus = getTransactionalBonus({
        component: TRANSACTION_COMPONENT_PLAN_SELECTOR,
        bonus: plan.bonus,
        producttype: plan.producttype,
        family: plan.family
    })

    return {
        id: plan.offerid,
        buttonText: Translator.get(plan.buy),
        buttonTextColorHex: buttonColorText,
        buttonBGColorHex: buttonColorBG,
        provider: plan.producttype,
        family: plan.family,
        offerid: plan.offerid,
        backgroundImage: backgroundAssetImage,
        providerLogo: providerLogo,
        providerLogoPlanSelector: providerLogoPlanSelector,
        planSelectorPrice, //[Plan Selector] Price Ej. $ 9999 / Mes
        planSelectorTax, //[Plan Selector] Tax/Periodicity Ej. IVA incluido
        planSelectorBonus, //[Plan Selector] Bonus Ej. Disfruta 30 días sin costo
        onPlanClick: handlePlanClick && typeof handlePlanClick === 'function' ? ()=>{handlePlanClick(plan)} : null,
        isButtonVisible,
        fallbackImage
    }
}

export const parseDetailPlan = (plans, labels) => plans.map(plan => {
    const { textNoBonus } = labels;
    const buttons = plans.filter((p)=>p.family === plan.family).map((plan)=>{

        const landingPrice = getTransactionalPrice({
            component: TRANSACTION_COMPONENT_LANDING,
            currency:plan.currency, 
            price:plan.price,
            producttype: plan.producttype,
            periodicity: plan.periodicity
            });

        const landingTax = getTransactionalTax({
            component: TRANSACTION_COMPONENT_LANDING,
            producttype: plan.producttype,
            periodicity: plan.periodicity
        });

        const landingBonus = getTransactionalBonus({
            component: TRANSACTION_COMPONENT_LANDING,
            bonus: plan.bonus,
            producttype: plan.producttype,
            family: plan.family
        });

        const landingBonusComplement = getTransactionalBonusComplement({
            component: TRANSACTION_COMPONENT_LANDING,
            bonus: plan.bonus,
        });

        return {...plan,  
            bonusButton: Translator.get(`${plan.bonus}_button`, textNoBonus),
            period: Translator.get(`${plan.bonus}_button`, textNoBonus),
            textTrial: Translator.get(`${plan.producttype}_subscriptionDescription_test_button`, ''),
            additionalInfo: Translator.get(`${plan.producttype}_subscriptionDescription_additionalInfo_label`, false),
            offerTitle: Translator.get(`${plan.producttype}_subscriptionDescription_offerTitle_label`, false),
            landingPrice,//[Landing Comercial] Price Ej. $ 9999 / Mes,
            landingTax,//[Landing Comercial] Tax/Periodicity Ej. IVA incluido,
            landingBonus,//[Landing Comercial] Bonus Ej. Disfruta 7 días sin costo <Blue Text>
            landingBonusComplement//[Landing Comercial] Bonus Sufix Ej. , después   
        }
    });

    return {
        id: plan.offerid,
        pbi: plan,
        buttons,
    }
});



// WEBPACK FOOTER //
// ./src/payments/PlanSelector/PlanSelectorUtils.js